// extracted by mini-css-extract-plugin
export default {"seoCrossLinks":"seoCrossLinks__NjRlZ","title":"title__YjI5N","list":"list__YzljY","link":"link__Njk2M"};